import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import 'leaflet/dist/leaflet.css';
// import '@/assets/static/css/app.scss';
// import 'bootstrap';
// import '@/assets/static/css/bootstrap.min.css';

Vue.config.productionTip = false

const localHosts = ['localhost', '127.0.0.1', '::1']
const isLocalHost = localHosts.includes(window.location.hostname)
// Production API routing switch:
// - false: use same-origin requests and rely on reverse-proxy routing
// - true: bypass the web origin and call the backend server directly on BACKEND_PORT
const FORCE_DIRECT_BACKEND_IN_PRODUCTION = true

const directBackendOrigin = `${window.location.protocol}//${window.location.hostname}`
const defaultApiDomain = isLocalHost
  ? 'http://127.0.0.1:5000'
  : (FORCE_DIRECT_BACKEND_IN_PRODUCTION ? directBackendOrigin : `${window.location.protocol}//${window.location.host}`)

Vue.prototype.$domain = (process.env.VUE_APP_API_BASE_URL || defaultApiDomain).replace(/\/$/, '')

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
